import {RootState} from '../../store';
import {ProductLineItem} from './types';

export const selectionSelector = (state: RootState): Record<string, ProductLineItem> =>
    state['product-line-items'].selection as Record<string, ProductLineItem>;
